export default __webpack_public_path__ + "static/cathedral-a65af0de632d9ccc130d3678ef0b20f8.png";